import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Product} from '../../../../models/product.model';
import {OrderItemService} from '../../../../services/order-item.service';
import {Order} from '../../../../models/order.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-product-image-cell',
  templateUrl: './product-image-cell.component.html',
  styleUrls: ['./product-image-cell.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductImageCellComponent {

  @Input() product: Product;

  @Input()  order: Order;

  constructor(private orderItemService: OrderItemService, private router: Router) {
  }

  get imageUrl(): string {
    return this.product.thumbnail;
  }

  get isProductRecommended(): boolean {
    return this.orderItemService.isProductRecommended(this.product, this.order);
  }

  onImageClicked() {
    this.router.navigate([this.product.productURL]);
  }


}
